import revalidator from "revalidator";
import {
  IErrrorProperty,
  IReturnMessage,
  ISchema,
  JSONSchema,
} from "./revalidator";
export * from "./revalidator";

export const validateData = <V, E, R>(
  values: V,
  schema: JSONSchema<V> | ISchema<V>
): { failed: false; values: R } | { failed: true; errors: E } => {
  const result: IReturnMessage = revalidator.validate(
    { ...values },
    schema as JSONSchema<V>,
    {
      additionalProperties: false,
      cast: true,
    }
  );

  if (result.valid) {
    console.debug(result);

    return {
      failed: false,
      values: values as unknown as R,
    };
  }

  console.debug(values);
  console.debug(result);

  return {
    failed: true,
    errors: result.errors.reduce(
      (r: E, error: IErrrorProperty) => ({
        ...r,
        [error.property]: error.message,
      }),
      {} as E
    ),
  };
};
